export const isShipmentAdjustable = (clubMemberShipment, clubPackage) => {
  if (
    clubPackage.status === 'Active' &&
    clubPackage.itemChoice === 'User Can Choose' &&
    (clubMemberShipment.processingStatus === 'Pending' ||
      clubMemberShipment.processingStatus === 'Skip')
  ) {
    return true;
  }
  return false;
};

export const listClubShipmentItems = (clubMemberShipment, clubPackage) => {
  const items = clubMemberShipment.items.map((item) => {
    const product = clubPackage.items.find(
      (pi) => pi.productVariantId === item.productVariantId
    );
    const newItem = {
      id: item.productVariantId,
      productVariantId: item.productVariantId,
      quantity: item.quantity,
      image: product.image,
      productTitle: product.productTitle,
      productVariantTitle: product.productVariantTitle,
      price: product.price,
      comparePrice: product.comparePrice,
      minQuantity: product.minQuantity,
      maxQuantity: product.maxQuantity
    };
    return newItem;
  });
  const { virtualCart } = clubMemberShipment;

  if (!virtualCart) {
    return items;
  }

  const productItems = items.map((item) => {
    const product = virtualCart.items.find(
      (pi) => pi.productVariantId === item.productVariantId
    );
    const newItem = item;
    newItem.price = product.price;
    newItem.comparePrice = product.comparePrice;
    return newItem;
  });
  return productItems;
};

export const listItemsForPackage = (clubMemberShipment, clubPackage) => {
  const controlledItems = clubPackage.items.filter(
    (i) => i.itemType === 'Controlled Subscription'
  );
  const userChoiceItems = clubPackage.items.filter(
    (i) => i.itemType !== 'Controlled Subscription'
  );

  let items = [...controlledItems, ...userChoiceItems];

  items = items.map((item) => {
    const newItem = { ...item };
    const itemInShipment = clubMemberShipment.items.find(
      (cms) => cms.productVariantId === item.productVariantId
    );
    if (itemInShipment) {
      newItem.minQuantity -= itemInShipment.quantity;
    }
    if (itemInShipment && newItem.maxQuantity) {
      newItem.maxQuantity -= itemInShipment.quantity;
    }
    if (newItem.minQuantity < 0) {
      newItem.minQuantity = 0;
    }
    if (newItem.maxQuantity && newItem.maxQuantity < 0) {
      newItem.maxQuantity = 0;
    }
    return newItem;
  });
  return items;
};

export const listItemsInPackageExceptProductVariant = (
  clubMemberShipment,
  clubPackage,
  productVariantId
) => {
  const items = listItemsForPackage(clubMemberShipment, clubPackage);
  const newItems = items.filter((i) => i.productVariantId !== productVariantId);
  return newItems;
};

export const itemInPackage = (productVariantId, clubPackage) => {
  const item = clubPackage.items.filter(
    (i) => i.productVariantId === productVariantId
  );
  return item[0];
};
